var map = {
	"./black-cumin.jpg": "e932",
	"./cinamon.jpg": "382e",
	"./cumin-seeds.jpg": "e4c5",
	"./dried-chillies.jpg": "e2a9",
	"./fennel-seeds.jpg": "1cc6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7926";